const translations = {
  "en": {
    "/ month": "/ month",
    "/ year": "/ year",
    "≈$40k sitting idle → a 4.5% position.": "≈$40k sitting idle → a 4.5% position.",
    "$34k more in 15 years, hands-off": "$34k more in 15 years, hands-off",
    "2 years sooner with Ed": "2 years sooner with Ed",
    "4 years sooner with Ed": "4 years sooner with Ed",
    "5 months longer with Ed": "5 months longer with Ed",
    "5 years sooner with Ed": "5 years sooner with Ed",
    "A simple shift that quietly hands you back money.": "A simple shift that quietly hands you back money.",
    "A tax move you're missing": "A tax move you're missing",
    "About how much do you earn?": "About how much do you earn?",
    "And how much goes out a month?": "And how much goes out a month?",
    "And how to get the keys sooner": "And how to get the keys sooner",
    "Balanced": "Balanced",
    "Build my $1M plan": "Build my $1M plan",
    "Build my debt-free plan": "Build my debt-free plan",
    "Build my home plan": "Build my home plan",
    "Build my idlecash plan": "Build my idlecash plan",
    "Build my retirement plan": "Build my retirement plan",
    "Build my runway plan": "Build my runway plan",
    "Build your safety cushion": "Build your safety cushion",
    "Ed extends budget by $80k for a larger home": "Ed extends budget by $80k for a larger home",
    "Ed keeps your savings rate on track.": "Ed auto-invests your full surplus, puts your idle cash to work, and optimizes your mix for tax.",
    "Ed lifts your buying power without overstretching you.": "Ed lifts your buying power without overstretching you.",
    "Ed optimizes your payoff order for you.": "Ed refinances you to a lower rate and puts your full surplus toward the balance.",
    "Ed runs the moves for you, automatically.": "Ed puts your idle cash to work, helps you invest your full surplus, and keeps your mix tax-smart.",
    "Go for growth": "Go for growth",
    "Got the top line. Now what goes out — roughly.": "Got the top line. Now what goes out — roughly.",
    "He frees up idle cash and builds your buffer, automatically.": "Ed frees up your idle cash and tops up your safety buffer automatically until you're covered.",
    "Here's your result": "Here's your result",
    "How long could I last with no income?": "How long could I last with no income?",
    "How long could you last with no income?": "How long could you last with no income?",
    "How much have you got invested?": "How much have you got invested?",
    "How much more could my idle cash earn?": "How much more could my idle cash earn?",
    "How old are you?": "How old are you?",
    "I'm Ed — your money person.": "I'm Ed — your money person.",
    "If income stopped today, here's how long.": "If income stopped today, here's how long.",
    "invested": "invested",
    "Last piece — what's already invested and working for you.": "Last piece — what's already invested and working for you.",
    "Lock a sharper mortgage rate": "Lock a sharper mortgage rate",
    "Now the other side of the ledger — no judgment, it helps me plan.": "Now the other side of the ledger — no judgment, it helps me plan.",
    "On your current pace, here's the age": "On your current pace, here's the age",
    "On your current pace, here's the year.": "On your current pace, here's the year.",
    "On your current pace, you're clear by": "On your current pace, you're clear by",
    "On your numbers today, here's your ceiling.": "On your numbers today, here's your ceiling.",
    "Out from under it, for good": "Out from under it, for good",
    "Peace of mind": "Peace of mind",
    "Play it safe": "Play it safe",
    "Put lazy money to work": "Put lazy money to work",
    "Put your idle cash to work": "Put your idle cash to work",
    "Rebalance to reach $1M sooner": "Rebalance to reach $1M sooner",
    "Round numbers are fine — I'll sharpen them as I get to know you.": "Round numbers are fine — I'll sharpen them as I get to know you.",
    "Shift your mix so the milestone arrives years earlier.": "Shift your mix so the milestone arrives years earlier.",
    "Six months of breathing room, set on autopilot.": "Six months of breathing room, set on autopilot.",
    "that's $1,000,000 — around age 57.": "that's $1,000,000 — around age 57.",
    "that's about $13,000 in the bank — gone by October.": "that's about $13,000 in the bank — gone by October.",
    "that's work-optional — about 14 years from now.": "that's work-optional — about 14 years from now.",
    "that's your last payment — about 6 years out.": "that's your last payment — about 6 years out.",
    "The cushion that lets you walk away": "The cushion that lets you walk away",
    "The seven-figure milestone": "The seven-figure milestone",
    "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.": "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.",
    "total": "total",
    "What do you owe?": "What do you owe?",
    "What home could I afford?": "What home could I afford?",
    "What home could you afford?": "What home could you afford?",
    "What should I call you?": "What should I call you?",
    "What's in the bank?": "What's in the bank?",
    "What's your style with money?": "What's your style with money?",
    "When can I stop working for money?": "When can I stop working for money?",
    "When can you stop working for money?": "When can you stop working for money?",
    "When the paycheck stops mattering": "When the paycheck stops mattering",
    "When will I be debt-free?": "When will I be debt-free?",
    "When will I hit my first $1M?": "When will I hit my first $1M?",
    "When will you be debt-free?": "When will you be debt-free?",
    "When will you hit your first $1M?": "When will you hit your first $1M?",
    "You’ve seen your Financial Fitness. Now — the thing you came in worried about.": "You’ve seen your Financial Fitness. Now — the thing you came in worried about.",
    "Your cash is barely working today.": "Your cash is barely working today.",
    "Your refinance window is open right now.": "Your refinance window is open right now."
  },
  "zh-tw": {
    "/ month": "/ 月",
    "/ year": "/年",
    "≈$40k sitting idle → a 4.5% position.": "≈$40k 閒置中 → 轉為 4.5% 部位。",
    "$34k more in 15 years, hands-off": "15 年後多賺 $34k，全自動打理",
    "2 years sooner with Ed": "搭配 Ed 提早 2 年達成",
    "4 years sooner with Ed": "透過 Ed 提早4年達成目標。",
    "5 months longer with Ed": "延長 5 個月，搭配 Ed",
    "5 years sooner with Ed": "搭配 Ed，提早5年達成。",
    "A simple shift that quietly hands you back money.": "簡單調整，默默為你帶回收益。",
    "A tax move you're missing": "你可能錯過的節稅策略",
    "About how much do you earn?": "你的收入大約是多少？",
    "And how much goes out a month?": "每月支出多少？",
    "And how to get the keys sooner": "以及如何提早取得存取權",
    "Balanced": "平衡",
    "Build my $1M plan": "建立我的$1M計畫",
    "Build my debt-free plan": "建立你的無債計畫",
    "Build my home plan": "建立我的購屋計畫",
    "Build my idlecash plan": "建立我的閒置資金計畫",
    "Build my retirement plan": "建立你的退休計畫",
    "Build my runway plan": "建立你的資金跑道計畫",
    "Build your safety cushion": "建立你的安全墊",
    "Ed extends budget by $80k for a larger home": "Ed 為購置更大住宅，將預算調增 $80k",
    "Ed keeps your savings rate on track.": "Ed 自動幫你把每月結餘全數投入、讓閒置現金動起來，還把配置調到最省稅。",
    "Ed lifts your buying power without overstretching you.": "Ed 提升你的購買力，且不致過度擴張。",
    "Ed optimizes your payoff order for you.": "Ed 幫你把利率再融資到更低，再把每月結餘全部拿去還本金。",
    "Ed runs the moves for you, automatically.": "Ed 讓你的閒置現金動起來、幫你把每月結餘全部投出去，還把配置維持在最省稅。",
    "Go for growth": "追求成長",
    "Got the top line. Now what goes out — roughly.": "收入有了。那大概花多少？",
    "He frees up idle cash and builds your buffer, automatically.": "Ed 幫你釋出閒置現金，自動補滿你的安全緩衝，直到足夠為止。",
    "Here's your result": "你的結果如下",
    "How long could I last with no income?": "若無收入，你的資金可支撐多久？",
    "How long could you last with no income?": "如果你沒有收入，你能撐多久？",
    "How much have you got invested?": "你目前投資了多少？",
    "How much more could my idle cash earn?": "你的閒置資金還能創造多少收益？",
    "How old are you?": "你幾歲？",
    "I'm Ed — your money person.": "我是 Ed — 你的理財專家。",
    "If income stopped today, here's how long.": "若今日收入中斷，你的資產可支撐多久？",
    "invested": "已投資",
    "Last piece — what's already invested and working for you.": "最後一項 — 你目前已持有且正在運作的投資。",
    "Lock a sharper mortgage rate": "鎖定更優惠的房貸利率",
    "Now the other side of the ledger — no judgment, it helps me plan.": "現在檢視紀錄的另一面——不帶評判，這能協助我規劃。",
    "On your current pace, here's the age": "以你目前的進度，這是你的年齡",
    "On your current pace, here's the year.": "照你現在的節奏，就是這一年。",
    "On your current pace, you're clear by": "以你目前的進度，預計可於",
    "On your numbers today, here's your ceiling.": "根據你今日的數據，這是你的預估上限。",
    "Out from under it, for good": "徹底擺脫，一勞永逸",
    "Peace of mind": "安心",
    "Play it safe": "穩健操作",
    "Put lazy money to work": "活化閒置資金",
    "Put your idle cash to work": "讓閒置資金為你工作",
    "Rebalance to reach $1M sooner": "再平衡以更快達成$1M目標",
    "Round numbers are fine — I'll sharpen them as I get to know you.": "先輸入整數即可，待我熟悉你的需求後，會再為你精確調整。",
    "Shift your mix so the milestone arrives years earlier.": "調整你的配置，讓目標提前數年達成。",
    "Six months of breathing room, set on autopilot.": "六個月緩衝期，自動執行。",
    "that's $1,000,000 — around age 57.": "那就是 100 萬美元——大約在 57 歲。",
    "that's about $13,000 in the bank — gone by October.": "帳上約有 13,000 美元，到十月便會化為烏有。",
    "that's work-optional — about 14 years from now.": "這代表可選擇不工作——大約在 14 年後。",
    "that's your last payment — about 6 years out.": "這是你的最後一筆款項 — 約在 6 年後。",
    "The cushion that lets you walk away": "讓你安心離場的緩衝",
    "The seven-figure milestone": "七位數里程碑",
    "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.": "為精準掌握，我只需要一個數字：你日常存放於支票與儲蓄帳戶的現金。只需拖曳即可。",
    "total": "總計",
    "What do you owe?": "你欠多少？",
    "What home could I afford?": "我能負擔得起什麼樣的房子？",
    "What home could you afford?": "你買得起什麼樣的房？",
    "What should I call you?": "我該怎麼稱呼你？",
    "What's in the bank?": "帳戶餘額為何？",
    "What's your style with money?": "你的理財風格是？",
    "When can I stop working for money?": "我什麼時候可以不用再為錢工作？",
    "When can you stop working for money?": "你何時能不再為薪水工作？",
    "When the paycheck stops mattering": "當薪水不再重要時",
    "When will I be debt-free?": "你何時能擺脫債務？",
    "When will I hit my first $1M?": "你何時能達到首個$1M目標？",
    "When will you be debt-free?": "你預計何時能清償所有債務？",
    "When will you hit your first $1M?": "你預計何時達成一百萬美元目標？",
    "You’ve seen your Financial Fitness. Now — the thing you came in worried about.": "你已查看財務健康度。現在，來處理你當初最擔心的問題。",
    "Your cash is barely working today.": "你的現金今日幾乎沒有產生收益。",
    "Your refinance window is open right now.": "你的再融資窗口目前已開啟。"
  }
};

export default translations;
